export default (state) => state.app.status.isReady;
